import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type UserInterfaceSettingsWorkerProfileEvents =
  | 'EDIT_SMART_FORM'
  | 'SAVE_SMART_FORM'
  | 'CANCEL_EDIT_SMART_FORM'
  | 'REORDER'
  | 'ADD_SMART_FORM_SECTION'
  | 'DELETE_SMART_FORM_SECTION';

export const userInterfaceSettingsWorkerProfile: Record<UserInterfaceSettingsWorkerProfileEvents, MixpanelEvent> = {
  EDIT_SMART_FORM: {
    eventDescription: 'Worker Profile Edit Smart Form',
    eventKey: 'worker-profile-edit-smart-form',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.INTERNAL_LINK_BUTTON
  },
  SAVE_SMART_FORM: {
    eventDescription: 'Worker Profile Save Smart Form',
    eventKey: 'worker-profile-save-smart-form',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  CANCEL_EDIT_SMART_FORM: {
    eventDescription: 'Worker Profile Cancel Edit Smart Form',
    eventKey: 'worker-profile-cancel-edit-smart-form',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CANCEL_BUTTON
  },
  REORDER: {
    eventDescription: 'Worker Profile Reorder Smart Forms',
    eventKey: 'worker-profile-reorder-smart-forms',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.DROP
  },
  ADD_SMART_FORM_SECTION: {
    eventDescription: 'Worker Profile Add Smart Form Section',
    eventKey: 'worker-profile-add-smart-form-section',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  DELETE_SMART_FORM_SECTION: {
    eventDescription: 'Worker Profile Delete Smart Form Section',
    eventKey: 'worker-profile-delete-smart-form-section',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  }
} as const;
